"use client";

import { createContext, useContext } from "react";

type Brand = {
  name: string;
  logoUrl: string;
};

const BrandContext = createContext<Brand>({ name: "HotspotKita", logoUrl: "" });

export function BrandProvider({
  name,
  logoUrl,
  children,
}: {
  name: string;
  logoUrl: string;
  children: React.ReactNode;
}) {
  return <BrandContext.Provider value={{ name, logoUrl }}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
